var _g, _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarViewJobs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) scale(.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 90.6738C300 76.135 288.172 64.3066 273.633 64.3066H226.758V45.3943C226.758 30.1371 214.345 17.7246 199.089 17.7246H100.912C85.6547 17.7246 73.2422 30.1371 73.2422 45.3943V64.3066H26.3672C11.8283 64.3066 0 76.135 0 90.6738V132.274C0 140.026 2.52422 149.693 11.7188 159.176V255.908C11.7188 270.447 23.5471 282.275 38.0859 282.275H261.914C276.453 282.275 288.281 270.447 288.281 255.908V159.176C297.472 149.698 300 140.034 300 132.274V90.6738ZM90.8203 45.3943C90.8203 39.8297 95.3473 35.3027 100.912 35.3027H199.089C204.653 35.3027 209.18 39.8297 209.18 45.3943V64.3066H90.8203V45.3943ZM17.5781 90.6738C17.5781 85.8275 21.5209 81.8848 26.3672 81.8848H273.633C278.479 81.8848 282.422 85.8275 282.422 90.6738V132.274C282.422 153.899 240.933 171.547 180.469 176.171V168.018C180.469 163.164 176.534 159.229 171.68 159.229H128.32C123.466 159.229 119.531 163.164 119.531 168.018V176.168C59.1217 171.538 17.5781 153.844 17.5781 132.274V90.6738ZM162.891 176.807V188.232C162.891 194.532 157.765 199.658 151.465 199.658H148.535C142.235 199.658 137.109 194.532 137.109 188.232V176.807H162.891ZM261.914 264.697H38.0859C33.2396 264.697 29.2969 260.754 29.2969 255.908V172.075C55.4672 185.486 82.9699 190.656 120.08 193.836C122.698 207.155 134.46 217.236 148.535 217.236H151.465C165.541 217.236 177.304 207.154 179.921 193.833C210.575 191.613 238.249 185.987 258.455 177.81C262.999 175.972 267.063 174.051 270.703 172.073V255.908C270.703 260.754 266.76 264.697 261.914 264.697Z",
    fill: "#2B2D70"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 12.5,
    width: 11.7,
    height: 9.5,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 17.2s1.8-3 5.1-3 5.1 3 5.1 3-1.8 3-5.1 3-5.1-3-5.1-3Z",
    stroke: "#2B2D70",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9,
    cy: 17.2,
    r: 1.4,
    stroke: "#2B2D70",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarViewJobs);
export default __webpack_public_path__ + "static/media/sidebar-view-jobs.0ea1ef54d9f1c1382900fd42e10da75e.svg";
export { ForwardRef as ReactComponent };